// Khung "gửi cho nhân viên": địa chỉ đăng nhập + SĐT + mật khẩu tạm (chỉ hiện lúc vừa tạo / vừa đặt lại — máy chủ không
// lưu mật khẩu đọc được), kèm nút chép cả đoạn để dán vào Zalo / tin nhắn.
import { useState } from 'react'
import { toast } from 'sonner'
import { Check, Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { formatPhoneVN } from '@/lib/format'

export function CredentialsBox({ name, phone, password }: { name: string; phone: string; password: string | null }) {
  const [copied, setCopied] = useState(false)
  const url = `${window.location.origin}/login`
  const text = password
    ? `Chào ${name}, tài khoản ShopTrack của bạn:\nĐăng nhập: ${url}\nSố điện thoại: ${phone}\nMật khẩu tạm: ${password}\nĐăng nhập lần đầu bạn sẽ được yêu cầu đặt mật khẩu mới.`
    : `Chào ${name}, bạn đã được thêm làm nhân viên trên ShopTrack.\nĐăng nhập: ${url} bằng số ${phone} và mật khẩu bạn đang dùng, rồi chọn đơn vị ở menu tài khoản.`
  return (
    <div className="space-y-3">
      <dl className="space-y-2 rounded-lg border border-rule bg-paperSoft p-3 text-sm">
        <div className="flex justify-between gap-3"><dt className="text-muted">Đăng nhập</dt><dd className="font-mono text-ink break-all text-right">{url}</dd></div>
        <div className="flex justify-between gap-3"><dt className="text-muted">Số điện thoại</dt><dd className="font-mono text-ink">{formatPhoneVN(phone)}</dd></div>
        <div className="flex justify-between gap-3">
          <dt className="text-muted">Mật khẩu</dt>
          <dd className="font-mono text-ink">{password ?? 'mật khẩu người đó đang dùng'}</dd>
        </div>
      </dl>
      {password && <p className="text-xs text-muted">Mật khẩu tạm chỉ hiện lần này.</p>}
      <Button
        type="button"
        variant="outline"
        className="h-11 w-full desktop:h-9"
        onClick={() => {
          navigator.clipboard.writeText(text).then(
            () => { setCopied(true); toast.success('Đã chép') },
            () => toast.error('Trình duyệt chặn sao chép'),
          )
        }}
      >
        {copied ? <Check className="mr-1.5 size-4 text-ok" /> : <Copy className="mr-1.5 size-4" />}
        {copied ? 'Đã chép' : 'Sao chép'}
      </Button>
    </div>
  )
}
